import { useMemo, useReducer } from "react";
import { combineReducers } from "./combine-reducers";
import { createSearchReducer } from "./reducers";
import { pagerReducer } from "./reducers/pager";
export var getSearchReducer = function (initialState, onClearState, getCriteriaFromPage) {
    var _a = combineReducers({
        pager: [pagerReducer, initialState.pager],
        search: [createSearchReducer(getCriteriaFromPage), initialState.search],
    }), reducer = _a[0], state = _a[1];
    var r = function (state, action) {
        var _a;
        if (action.type === "CLEAR_CRITERIA" && onClearState) {
            return (_a = onClearState(state)) !== null && _a !== void 0 ? _a : state;
        }
        return reducer(state, action);
    };
    return [r, state];
};
export var useSearchReducer = function (initialState, onClearSearch, getCriteriaFromPage) {
    var _a = useMemo(function () { return getSearchReducer(initialState, onClearSearch, getCriteriaFromPage); }, [getCriteriaFromPage, initialState, onClearSearch]), reducer = _a[0], state = _a[1];
    return useReducer(reducer, state);
};
//# sourceMappingURL=use-search-reducer.js.map